// import React, { useEffect, useState } from "react";
// import {
//   Card,
//   CardBody,
//   CardHeader,
//   Row,
//   Col,
//   Form,
//   FormGroup,
//   Label,
//   Input,
//   Button,
// } from "reactstrap";
// import swal from "sweetalert";
// import { useNavigate, useLocation } from "react-router-dom";
// import axiosConfig from "../../AxiosConfig.js";

// const CreateTarget = () => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const editData = location.state;

//   const isEditMode =
//     editData?.editMode === true;

//   const editTargetId =
//     editData?.targetId || "";
//   const TARGET_STORAGE_KEY = "create_target_form";
//   const user = JSON.parse(localStorage.getItem("userData"));

//   const [loading, setLoading] = useState(false);

//   const [products, setProducts] = useState([]);

//   const [reportType, setReportType] = useState("monthly");
//   const [selectedMonth, setSelectedMonth] = useState("");
//   const [monthlyQty, setMonthlyQty] = useState([]);
//   const [financialYear, setFinancialYear] = useState("");

//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [productTypeFilter, setProductTypeFilter] = useState("");
//   const [targetQty, setTargetQty] = useState("");


//   const [inputDetails, setInputDetails] = useState([]);

//   const [outputDetails, setOutputDetails] = useState([]);
//   const getFinancialYear = () => {
//     const today = new Date();

//     const year = today.getFullYear();

//     const month = today.getMonth() + 1;

//     if (month >= 4) {
//       return `${year}-${year + 1}`;
//     }

//     return `${year - 1}-${year}`;
//   };

//   const getFinancialYearOptions = () => {
//     const current = new Date().getFullYear();

//     let list = [];

//     for (let i = -3; i <= 3; i++) {
//       const start = current + i;

//       list.push(`${start}-${start + 1}`);
//     }

//     return list;
//   };
//   const getFinancialYearMonths = () => {
//     return [
//       "April",
//       "May",
//       "June",
//       "July",
//       "August",
//       "September",
//       "October",
//       "November",
//       "December",
//       "January",
//       "February",
//       "March",
//     ];
//   };


//   useEffect(() => {
//     fetchProducts();

//     if (!isEditMode) {
//       setFinancialYear(getFinancialYear());
//     }
//   }, []);

//   //----------------------------------------------------
//   // Fetch Products
//   //----------------------------------------------------
//   useEffect(() => {
//     if (isEditMode && products.length > 0) {
//       fetchTargetById(editTargetId);
//       return;
//     }

//     const savedData =
//       localStorage.getItem(
//         TARGET_STORAGE_KEY
//       );

//     if (!savedData) return;

//     try {
//       const parsed =
//         JSON.parse(savedData);

//       if (parsed.inputDetails) {
//         setInputDetails(
//           parsed.inputDetails
//         );
//       }

//       if (parsed.outputDetails) {
//         setOutputDetails(
//           parsed.outputDetails
//         );
//       }

//       if (parsed.targetQty) {
//         setTargetQty(
//           parsed.targetQty
//         );
//       }

//       if (parsed.productTypeFilter) {
//         setProductTypeFilter(
//           parsed.productTypeFilter
//         );
//       }

//       if (parsed.reportType) {
//         setReportType(
//           parsed.reportType
//         );
//       }

//       if (parsed.financialYear) {
//         setFinancialYear(
//           parsed.financialYear
//         );
//       }

//       if (parsed.selectedProductId) {
//         const product =
//           products.find(
//             (p) =>
//               String(p._id) ===
//               String(
//                 parsed.selectedProductId
//               )
//           );

//         if (product) {
//           setSelectedProduct(product);
//         }
//       }
//     } catch (error) {
//       console.log(
//         "Local storage parse error:",
//         error
//       );
//     }
//   }, [products, isEditMode, editTargetId]);

//   const fetchProducts = async () => {
//     try {
//       if (!user?.database) return;

//       const res = await axiosConfig.get(
//         `/product/view-product-purchase/${user.database}`
//       );
//       const productList = res?.data?.Product || [];

//       setProducts(productList);
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   const fetchTargetById = async (id) => {
//     try {
//       if (!id) return;

//       setLoading(true);

//       const res = await axiosConfig.get(
//         `/production-steps/view-by-target-id/${id}`
//       );

//       console.log(
//         "VIEW TARGET BY ID RESPONSE =>",
//         res?.data
//       );

//       const data =
//         res?.data?.data ||
//         res?.data?.target ||
//         res?.data;

//       if (!data) {
//         swal(
//           "Error",
//           "Target data not found",
//           "error"
//         );
//         return;
//       }

//       populateEditForm(data);

//     } catch (error) {
//       console.error(
//         "View Worker Target Error:",
//         error
//       );

//       swal(
//         "Error",
//         error?.response?.data?.message ||
//         "Unable to load target",
//         "error"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };
//   const populateEditForm = (data) => {


//     setReportType(
//       data?.reportType || "monthly"
//     );

//     // -----------------------------
//     // FINANCIAL YEAR
//     // -----------------------------

//     setFinancialYear(
//       data?.financialYear || getFinancialYear()
//     );


//     const monthArray = Array.isArray(data?.month)
//       ? data.month
//       : [];

//     const existingMonthlyQty = monthArray.map((item) => {
//       const monthName = Object.keys(item || {})[0];

//       return {
//         month: monthName,
//         qty: Number(item?.[monthName] || 0),
//       };
//     });

//     setMonthlyQty(existingMonthlyQty);

//     // Last/current active month identify karo
//     if (data?.reportType === "monthly") {
//       const months = getFinancialYearMonths();

//       if (data?.reportType === "monthly") {
//         setSelectedMonth(editData?.month || "");
//       }
//     }

//     const targetProducts =
//       Array.isArray(data?.products)
//         ? data.products
//         : [];

//     const firstProduct =
//       targetProducts[0];

//     if (!firstProduct) {
//       return;
//     }

//     setTargetQty(
//       firstProduct?.targetQty || ""
//     );

//     const product = products.find(
//       (item) =>
//         String(item?._id) ===
//         String(firstProduct?.productId)
//     );

//     if (product) {
//       setSelectedProduct(product);

//       const details =
//         getProductDetails(product);

//       const updatedDetails =
//         details.map((item) => ({
//           ...item,
//           operator:
//             firstProduct
//               ?.inputProductDetails
//               ?.find(
//                 (saved) =>
//                   String(saved?.unit)
//                     .trim()
//                     .toLowerCase() ===
//                   String(item?.unit)
//                     .trim()
//                     .toLowerCase()
//               )?.operator ||
//             item?.operator ||
//             "*",
//         }));

//       setInputDetails(
//         updatedDetails
//       );


//       const savedOutput =
//         Array.isArray(
//           firstProduct?.outputProductDetails
//         )
//           ? firstProduct.outputProductDetails
//           : [];

//       setOutputDetails(
//         savedOutput
//       );

//       // -----------------------------
//       // PRODUCT TYPE
//       // -----------------------------

//       setProductTypeFilter(
//         product?.producttype || ""
//       );
//     }
//   };
//   const saveTargetToLocal = ({
//     updatedInputDetails = inputDetails,
//     updatedTargetQty = targetQty,
//     updatedProduct = selectedProduct,
//     updatedOutputDetails = outputDetails,
//     updatedProductType = productTypeFilter,
//     updatedReportType = reportType,
//     updatedFinancialYear = financialYear,
//   }) => {
//     const data = {
//       inputDetails: updatedInputDetails,
//       outputDetails: updatedOutputDetails,

//       targetQty: updatedTargetQty,

//       selectedProductId:
//         updatedProduct?._id || "",

//       productTypeFilter:
//         updatedProductType,

//       reportType:
//         updatedReportType,

//       financialYear:
//         updatedFinancialYear,
//     };

//     localStorage.setItem(
//       TARGET_STORAGE_KEY,
//       JSON.stringify(data)
//     );
//   };
//   //----------------------------------------------------
//   // Product Details
//   //----------------------------------------------------
//   const filteredProducts = products.filter((product) => {
//     if (!productTypeFilter) {
//       return true;
//     }

//     return (
//       String(product?.producttype || "")
//         .trim()
//         .toLowerCase() ===
//       productTypeFilter.trim().toLowerCase()
//     );
//   });

//   const getProductDetails = (product) => {
//     if (!product) return [];

//     const details = Array.isArray(product?.productDetails)
//       ? product.productDetails
//       : [];

//     if (details.length === 0) return [];

//     const productDetail = details[0];

//     const selectedUnits = Array.isArray(
//       productDetail?.selectedUnits
//     )
//       ? productDetail.selectedUnits
//         .filter((item) => Number(item?.qty || 0) > 0)
//         .map((item) => ({
//           unit: item?.unit || "",
//           qty: Number(item?.qty || 0),
//           source: "selectedUnits",
//         }))
//       : [];

//     // ==========================================
//     // CHILD PRODUCT UNITS
//     // sheet + qty 0 dono remove
//     // ==========================================
//     const childProduct =
//       typeof productDetail?.productId === "object"
//         ? productDetail.productId
//         : null;

//     const productUnits = Array.isArray(childProduct?.Units)
//       ? childProduct.Units
//         .filter((item) => {
//           const unit = String(item?.unit || "")
//             .trim()
//             .toLowerCase();

//           const qty = Number(item?.qty || 0);

//           return (
//             unit !== "sheet" &&
//             qty > 0
//           );
//         })
//         .map((item) => ({
//           unit: item?.unit || "",
//           qty: Number(item?.qty || 0),
//           source: "productUnits",
//         }))
//       : [];

//     // ==========================================
//     // ONLY VALID UNITS
//     // ==========================================
//     return [
//       ...selectedUnits,
//       ...productUnits,
//     ].map((item) => ({
//       ...item,
//       operator: item?.operator || "*",
//     }));
//   };

//   const handleProductChange = (e) => {
//     const product = products.find(
//       (item) => item._id === e.target.value
//     );

//     setSelectedProduct(product);

//     const details = getProductDetails(product);

//     // Default operator *
//     const updatedDetails = details.map((item) => ({
//       ...item,
//       operator: item.operator || "*",
//     }));

//     setInputDetails(updatedDetails);

//     calculateOutput(
//       updatedDetails,
//       targetQty
//     );

//     // LOCAL STORAGE
//     saveTargetToLocal({
//       updatedProduct: product,
//       updatedInputDetails: updatedDetails,
//     });
//   };

//   const handleQtyChange = (e) => {
//     const qty = Number(e.target.value);

//     setTargetQty(qty);

//     calculateOutput(inputDetails, qty);

//     if (reportType === "monthly" && selectedMonth) {
//       calculateMonthlyQty(
//         qty,
//         selectedMonth,
//         isEditMode
//       );
//     } else if (reportType === "yearly") {
//       calculateMonthlyQty(qty);
//     }
//   };
//   const calculateOperatorValue = (
//     targetQty,
//     operator,
//     value
//   ) => {
//     const target = Number(targetQty) || 0;
//     const val = Number(value) || 0;

//     switch (operator) {
//       case "+":
//         return target + val;

//       case "-":
//         return target - val;

//       case "*":
//         return target * val;

//       case "/":
//         return val !== 0 ? target / val : 0;

//       case "%":
//         return (target * val) / 100;

//       default:
//         return target;
//     }
//   };



//   const calculateOutput = (details, qty, product = selectedProduct) => {
//     const target = Number(qty || 0);

//     if (!Array.isArray(details) || details.length === 0) {
//       setOutputDetails([]);
//       return;
//     }

//     const productQtyDetails = Array.isArray(product?.productQtyDetails)
//       ? product.productQtyDetails
//       : [];

//     const calculated = details.map((item) => {
//       const inputQty = Number(item?.qty || 0);
//       const operator = item?.operator || "*";

//       const unitName = String(item?.unit || "")
//         .trim()
//         .toLowerCase();

//       // Sirf child/productUnits se aaye hue SQINCH aur Kg
//       const isChildSqInch =
//         item?.source === "productUnits" &&
//         unitName === "sqinch";

//       const isChildWeight =
//         item?.source === "productUnits" &&
//         (unitName === "kg" ||
//           unitName.includes("kilogram"));

//       // productQtyDetails me child ki qty
//       const childQty = Number(
//         productQtyDetails?.find((p) => {
//           const pId =
//             typeof p?.productId === "object"
//               ? p?.productId?._id
//               : p?.productId;

//           const childId =
//             typeof product?.productDetails?.[0]?.productId === "object"
//               ? product?.productDetails?.[0]?.productId?._id
//               : product?.productDetails?.[0]?.productId;

//           return String(pId) === String(childId);
//         })?.qty || 0
//       );

//       let calculatedQty = 0;

//       // ==========================================
//       // ONLY CHILD SQINCH / WEIGHT
//       // ==========================================
//       if (
//         (isChildSqInch || isChildWeight) &&
//         childQty > 0
//       ) {
//         calculatedQty =
//           (inputQty / childQty) * target;
//       } else {
//         // ==========================================
//         // BAAKI SAB SAME OLD CALCULATION
//         // ==========================================
//         switch (operator) {
//           case "+":
//             calculatedQty = target + inputQty;
//             break;

//           case "-":
//             calculatedQty = target - inputQty;
//             break;

//           case "*":
//             calculatedQty = target * inputQty;
//             break;

//           case "/":
//             calculatedQty =
//               inputQty !== 0
//                 ? target / inputQty
//                 : 0;
//             break;

//           case "%":
//             calculatedQty =
//               (target * inputQty) / 100;
//             break;

//           default:
//             calculatedQty = target * inputQty;
//         }
//       }

//       return {
//         unit: item?.unit || "",
//         inputQty,
//         targetQty: target,
//         operator,
//         calculatedQty,
//       };
//     });

//     setOutputDetails(calculated);

//     saveTargetToLocal({
//       updatedInputDetails: details,
//       updatedTargetQty: target,
//       updatedOutputDetails: calculated,
//     });
//   };
//   const calculateMonthlyQty = (
//     qty,
//     month = "",
//     preservePrevious = false,
//     oldMonthlyData = null
//   ) => {
//     const newTarget = Number(qty) || 0;

//     const months = getFinancialYearMonths();

//     if (!newTarget) {
//       setMonthlyQty([]);
//       return;
//     }

//     // ==========================================
//     // YEARLY
//     // Target / 12
//     // ==========================================
//     if (reportType === "yearly") {
//       const perMonth = newTarget / 12;

//       const result = months.map((monthName) => ({
//         month: monthName,
//         qty: perMonth,
//       }));

//       setMonthlyQty(result);
//       return;
//     }

//     // ==========================================
//     // MONTHLY
//     // ==========================================
//     const selectedIndex = months.indexOf(month);

//     if (selectedIndex === -1) {
//       return;
//     }

//     const oldData = Array.isArray(oldMonthlyData)
//       ? oldMonthlyData
//       : Array.isArray(monthlyQty)
//         ? monthlyQty
//         : [];

//     const result = months.map(
//       (monthName, index) => {

//         // ======================================
//         // EDIT MODE
//         // Selected month se pehle old value
//         // same rahegi
//         // ======================================
//         if (
//           preservePrevious &&
//           index < selectedIndex
//         ) {
//           const oldItem = oldData.find(
//             (item) =>
//               item?.month === monthName
//           );

//           return {
//             month: monthName,
//             qty: Number(oldItem?.qty || 0),
//           };
//         }

//         // ======================================
//         // Selected month onward
//         // FULL TARGET QTY
//         // ======================================
//         return {
//           month: monthName,
//           qty: newTarget,
//         };
//       }
//     );

//     setMonthlyQty(result);
//   };
//   const validateForm = () => {
//     if (!reportType) {
//       swal(
//         "Warning",
//         "Select Target Type",
//         "warning"
//       );
//       return false;
//     }

//     if (!financialYear) {
//       swal(
//         "Warning",
//         "Select Financial Year",
//         "warning"
//       );
//       return false;
//     }

//     if (!selectedProduct) {
//       swal(
//         "Warning",
//         "Select Product",
//         "warning"
//       );
//       return false;
//     }

//     if (
//       Number(targetQty) <= 0
//     ) {
//       swal(
//         "Warning",
//         "Enter Target Qty",
//         "warning"
//       );
//       return false;
//     }

//     return true;
//   };

//   //----------------------------------------------------
//   // Payload
//   //----------------------------------------------------

//   const buildPayload = () => {
//     return {
//       created_by: user?._id,
//       database: user?.database,
//       reportType,
//       financialYear,

//       month:
//         monthlyQty.map((item) => ({
//           [item.month]: Number(item.qty || 0),
//         })),

//       products: [
//         {
//           productId: selectedProduct?._id,
//           productName: selectedProduct?.Product_Title,
//           targetQty: Number(targetQty) || 0,

//           inputProductDetails: inputDetails.map((item) => ({
//             unit: item?.unit || "",
//             qty: Number(item?.qty) || 0,
//             source: item?.source || "",
//             operator: item?.operator || "*",
//           })),

//           outputProductDetails: outputDetails.map((item) => ({
//             unit: item?.unit || "",
//             inputQty: Number(item?.inputQty) || 0,
//             targetQty: Number(item?.targetQty) || 0,
//             operator: item?.operator || "*",
//             calculatedQty: Number(item?.calculatedQty) || 0,
//           })),
//         },
//       ],
//     };
//   };

//   //----------------------------------------------------
//   // Submit
//   //----------------------------------------------------

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!validateForm()) {
//       return;
//     }

//     try {
//       setLoading(true);

//       const payload = buildPayload();

//       console.log(
//         "FINAL TARGET PAYLOAD =>",
//         payload
//       );

//       let res;

//       // ====================================
//       // EDIT
//       // ====================================
//       console.log("EDIT TARGET ID =>", editTargetId);
//       console.log("UPDATE PAYLOAD =>", JSON.stringify(payload, null, 2));
//       if (isEditMode && editTargetId) {
//         res = await axiosConfig.put(
//           `/production-steps/update-workerTaget/${editTargetId}`,
//           payload
//         );
//         console.log("PUT STATUS =>", res?.status);
//         console.log("PUT RESPONSE =>", res?.data);
//         debugger
//       }

//       // ====================================
//       // CREATE
//       // ====================================

//       else {
//         res = await axiosConfig.post(
//           "/production-steps/save-worker-target",
//           payload
//         );
//       }

//       console.log(
//         "TARGET SAVE RESPONSE =>",
//         res?.data
//       );

//       if (
//         res?.status === 200 ||
//         res?.status === 201 ||
//         res?.data?.status
//       ) {
//         localStorage.removeItem(
//           TARGET_STORAGE_KEY
//         );

//         swal(
//           "Success",
//           isEditMode
//             ? "Target Updated Successfully"
//             : "Target Saved Successfully",
//           "success"
//         );

//         navigate(
//           "/sales-and-purchases?view=targets"
//         );
//       } else {
//         swal(
//           "Error",
//           isEditMode
//             ? "Unable to update target"
//             : "Unable to save target",
//           "error"
//         );
//       }

//     } catch (error) {
//       console.log(
//         "Target Submit Error:",
//         error
//       );

//       swal(
//         "Error",
//         error?.response?.data?.message ||
//         "Something Went Wrong",
//         "error"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };
//   return (
//     <div className="container-fluid">

//       <Card>

//         <CardHeader>
//           <h3>
//             {isEditMode
//               ? "Edit Target"
//               : "Create Target"}
//           </h3>
//         </CardHeader>

//         <CardBody>

//           <Form onSubmit={handleSubmit}>

//             <Row>

//               {/* Target Type */}
//               <Col md="3">
//                 <FormGroup>
//                   <Label>
//                     Target Type
//                   </Label>

//                   <Input
//                     type="select"
//                     value={reportType}
//                     onChange={(e) => {
//                       const type = e.target.value;

//                       setReportType(type);

//                       if (type === "yearly") {
//                         // Yearly = Apr to Mar
//                         if (targetQty) {
//                           calculateMonthlyQty(
//                             targetQty
//                           );
//                         }
//                       } else {
//                         // Monthly me fresh month select karna hoga
//                         setMonthlyQty([]);
//                         setSelectedMonth("");
//                       }
//                     }}
//                   >
//                     <option value="monthly">
//                       Monthly
//                     </option>

//                     <option value="yearly">
//                       Yearly
//                     </option>
//                   </Input>
//                 </FormGroup>
//               </Col>


//               {/* Financial Year */}
//               <Col md="3">
//                 <FormGroup>

//                   <Label>
//                     Financial Year
//                   </Label>

//                   <Input
//                     type="select"
//                     value={financialYear}
//                     onChange={(e) =>
//                       setFinancialYear(e.target.value)
//                     }
//                   >
//                     {getFinancialYearOptions().map(
//                       (item) => (
//                         <option
//                           key={item}
//                           value={item}
//                         >
//                           {item}
//                         </option>
//                       )
//                     )}
//                   </Input>

//                 </FormGroup>
//               </Col>

//               {reportType === "monthly" && (
//                 <Col md="3">
//                   <FormGroup>
//                     <Label>
//                       Month
//                     </Label>

//                     <Input
//                       type="select"
//                       value={selectedMonth}
//                       onChange={(e) => {
//                         const month = e.target.value;

//                         setSelectedMonth(month);

//                         if (month && targetQty) {
//                           calculateMonthlyQty(
//                             targetQty,
//                             month,
//                             isEditMode,
//                             monthlyQty
//                           );
//                         } else {
//                           setMonthlyQty([]);
//                         }
//                       }}
//                     >
//                       <option value="">
//                         Select Month
//                       </option>

//                       {getFinancialYearMonths().map((month) => (
//                         <option
//                           key={month}
//                           value={month}
//                         >
//                           {month}
//                         </option>
//                       ))}
//                     </Input>
//                   </FormGroup>
//                 </Col>
//               )}
//               {/* PRODUCT TYPE */}
//               <Col md="3">
//                 <FormGroup>

//                   <Label>
//                     Product Type
//                   </Label>

//                   <Input
//                     type="select"
//                     value={productTypeFilter}

//                     onChange={(e) => {
//                       setProductTypeFilter(e.target.value);

//                       setSelectedProduct(null);

//                       setInputDetails([]);

//                       setOutputDetails([]);

//                       setTargetQty("");
//                     }}
//                   >

//                     <option value="">
//                       Select Product Type
//                     </option>

//                     <option value="raw material">
//                       Raw Material
//                     </option>

//                     <option value="final product">
//                       Final Product
//                     </option>

//                   </Input>

//                 </FormGroup>
//               </Col>


//               {/* PRODUCT */}
//               <Col md="3">
//                 <FormGroup>

//                   <Label>
//                     Product
//                   </Label>

//                   <Input
//                     type="select"
//                     value={
//                       selectedProduct?._id || ""
//                     }
//                     onChange={
//                       handleProductChange
//                     }
//                     disabled={!productTypeFilter}
//                   >

//                     <option value="">
//                       {
//                         productTypeFilter
//                           ? "Select Product"
//                           : "First Select Product Type"
//                       }
//                     </option>

//                     {filteredProducts.map(
//                       (item) => (
//                         <option
//                           key={item._id}
//                           value={item._id}
//                         >
//                           {item.Product_Title}
//                         </option>
//                       )
//                     )}

//                   </Input>

//                 </FormGroup>
//               </Col>

//             </Row>


//             <CardHeader>
//               <h5 className="mb-0">Input Product Details</h5>
//             </CardHeader>

//             <CardBody>
//               {inputDetails.length === 0 ? (
//                 <div className="text-muted">
//                   Select product to view input units
//                 </div>
//               ) : (
//                 <Row>
//                   {inputDetails.map((item, index) => (
//                     <Col
//                       md="3"
//                       sm="6"
//                       xs="12"
//                       key={index}
//                       className="mb-3"
//                     >
//                       <div
//                         className="border rounded p-3 h-100"
//                         style={{
//                           background: "#fff",
//                           boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
//                         }}
//                       >

//                         {/* UNIT NAME + OPERATOR */}
//                         <div className="d-flex align-items-center justify-content-between mb-2">

//                           {/* UNIT NAME */}
//                           <strong>
//                             {item?.unit || "-"}
//                           </strong>

//                           {/* OPERATOR */}
//                           <Input
//                             type="select"
//                             bsSize="sm"
//                             value={item?.operator || "*"}
//                             style={{
//                               width: "65px",
//                               minWidth: "65px",
//                               fontWeight: "bold",
//                               textAlign: "center",
//                             }}

//                             onChange={(e) => {
//                               const updatedDetails = [...inputDetails];

//                               updatedDetails[index] = {
//                                 ...updatedDetails[index],
//                                 operator: e.target.value,
//                               };

//                               setInputDetails(updatedDetails);

//                               calculateOutput(
//                                 updatedDetails,
//                                 targetQty
//                               );
//                             }}
//                           >
//                             <option value="*">×</option>
//                             <option value="+">+</option>
//                             <option value="-">−</option>
//                             <option value="/">÷</option>
//                             <option value="%">%</option>
//                           </Input>

//                         </div>

//                         {/* INPUT QTY */}
//                         <Input
//                           type="number"
//                           bsSize="sm"
//                           value={item?.qty ?? 0}
//                           readOnly
//                           style={{
//                             fontWeight: "500",
//                             background: "#f8f9fa",
//                           }}
//                         />

//                       </div>
//                     </Col>
//                   ))}
//                 </Row>
//               )}
//             </CardBody>

//             {/* ===========================
//                   TARGET QTY
//           ============================== */}

//             <Row className="mt-3">

//               <Col md="3">

//                 <FormGroup>

//                   <Label>
//                     Target Qty
//                   </Label>

//                   <Input
//                     type="number"
//                     min="1"
//                     value={targetQty}
//                     onChange={
//                       handleQtyChange
//                     }
//                   />

//                 </FormGroup>

//               </Col>

//             </Row>


//             <Card className="mt-3">
//               <CardHeader>
//                 <h5>Output Product Details</h5>
//               </CardHeader>

//               <CardBody>
//                 {outputDetails.length === 0 ? (
//                   <div className="text-muted">
//                     Enter target quantity to calculate output
//                   </div>
//                 ) : (
//                   <div className="table-responsive">
//                     <table className="table table-bordered">
//                       <thead>
//                         <tr>
//                           <th>Unit</th>
//                           <th>Input Qty</th>
//                           <th>Operator</th>
//                           <th>Target Qty</th>
//                           <th>Calculated Qty</th>
//                         </tr>
//                       </thead>

//                       <tbody>
//                         {outputDetails.map((item, index) => (
//                           <tr key={index}>
//                             <td>{item?.unit}</td>

//                             <td>{item?.inputQty}</td>

//                             <td>
//                               {item?.operator === "*"
//                                 ? "×"
//                                 : item?.operator === "/"
//                                   ? "÷"
//                                   : item?.operator}
//                             </td>

//                             <td>{item?.targetQty}</td>

//                             <td>
//                               <strong>
//                                 {Number(
//                                   item?.calculatedQty || 0
//                                 ).toFixed(2)}
//                               </strong>
//                             </td>
//                           </tr>
//                         ))}
//                       </tbody>
//                     </table>
//                   </div>
//                 )}
//               </CardBody>
//             </Card>
//             {/* ===========================
//                  SAVE BUTTON
//           ============================== */}

//             <Row className="mt-3">

//               <Col
//                 md="12"
//                 className="text-center"
//               >

//                 <Button
//                   color="primary"
//                   type="submit"
//                   disabled={loading}
//                 >
//                   {loading
//                     ? isEditMode
//                       ? "Updating..."
//                       : "Saving..."
//                     : isEditMode
//                       ? "Update Target"
//                       : "Save Target"}
//                 </Button>

//                 <Button
//                   style={{ marginLeft: "5px" }}
//                   color="secondary"
//                   className="ml-2"
//                   onClick={() =>
//                     navigate(
//                       "/sales-and-purchases?view=targets"
//                     )
//                   }
//                 >
//                   Cancel
//                 </Button>

//               </Col>

//             </Row>

//           </Form>

//         </CardBody>

//       </Card>

//     </div>
//   );

// };

// export default CreateTarget;





import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
} from "reactstrap";
import swal from "sweetalert";
import { useNavigate, useLocation } from "react-router-dom";
import axiosConfig from "../../AxiosConfig.js";

const CreateTarget = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const editData = location.state;

  const isEditMode = editData?.editMode === true;

  const editTargetId = editData?.targetId || "";

  const TARGET_STORAGE_KEY = "create_target_form";

  const user = JSON.parse(localStorage.getItem("userData"));

  const [loading, setLoading] = useState(false);

  const [products, setProducts] = useState([]);

  const [reportType, setReportType] = useState("monthly");

  const [selectedMonth, setSelectedMonth] = useState("");

  const [monthlyQty, setMonthlyQty] = useState([]);

  const [financialYear, setFinancialYear] = useState("");

const [productTypeFilter, setProductTypeFilter] =
  useState("final product");
  // =========================================================
  // MULTIPLE PRODUCTS
  // =========================================================

  const createEmptyProduct = () => ({
    id: Date.now() + Math.random(),
    productId: "",
    product: null,
    targetQty: "",
    inputDetails: [],
    outputDetails: [],
    rawMaterialDetails: [],
  });

  const [targetProducts, setTargetProducts] = useState([
    createEmptyProduct(),
  ]);
  const [unitOperators, setUnitOperators] = useState({});
  // =========================================================
  // FINANCIAL YEAR
  // =========================================================

  const getFinancialYear = () => {
    const today = new Date();

    const year = today.getFullYear();

    const month = today.getMonth() + 1;

    if (month >= 4) {
      return `${year}-${year + 1}`;
    }

    return `${year - 1}-${year}`;
  };

  const getFinancialYearOptions = () => {
    const current = new Date().getFullYear();

    let list = [];

    for (let i = -3; i <= 3; i++) {
      const start = current + i;

      list.push(`${start}-${start + 1}`);
    }

    return list;
  };

  const getFinancialYearMonths = () => {
    return [
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
      "January",
      "February",
      "March",
    ];
  };

  // =========================================================
  // INITIAL LOAD
  // =========================================================

  useEffect(() => {
    fetchProducts();

    if (!isEditMode) {
      setFinancialYear(getFinancialYear());
    }
  }, []);

  // =========================================================
  // FETCH PRODUCTS
  // =========================================================

  useEffect(() => {
    if (isEditMode && products.length > 0) {
      fetchTargetById(editTargetId);

      return;
    }

    if (isEditMode) {
      return;
    }

    const savedData = localStorage.getItem(TARGET_STORAGE_KEY);

    if (!savedData) {
      return;
    }

    try {
      const parsed = JSON.parse(savedData);

      // -------------------------------------------------------
      // OLD LOCAL STORAGE DATA
      // -------------------------------------------------------

      if (Array.isArray(parsed?.targetProducts)) {
        const restoredProducts = parsed.targetProducts.map((item) => {
          const product = products.find(
            (p) => String(p?._id) === String(item?.productId)
          );
          const inputDetails =
            item?.inputDetails?.length > 0
              ? item.inputDetails
              : getProductDetails(product);

          const outputDetails =
            item?.outputDetails?.length > 0
              ? item.outputDetails
              : calculateProductOutput(
                inputDetails,
                item?.targetQty,
                product
              );
          const rawMaterialDetails =
            Array.isArray(item?.rawMaterialDetails)
              ? item.rawMaterialDetails.map((rawItem) => ({
                productId:
                  typeof rawItem?.productId === "object"
                    ? rawItem.productId?._id
                    : rawItem?.productId || "",

                qty:
                  rawItem?.qty ?? "",

                step_Name:
                  Array.isArray(rawItem?.step_Name)
                    ? rawItem.step_Name
                    : rawItem?.step_Name
                      ? [rawItem.step_Name]
                      : [],
              }))
              : [];

          return {
            id: item?.id || Date.now() + Math.random(),
            productId: item?.productId || "",
            product,
            targetQty: item?.targetQty ?? "",
            inputDetails,
            outputDetails,
            rawMaterialDetails,
          };
        });

        if (restoredProducts.length > 0) {
          setTargetProducts(restoredProducts);
        }
      }

      if (parsed?.reportType) {
        setReportType(parsed.reportType);
      }

      if (parsed?.financialYear) {
        setFinancialYear(parsed.financialYear);
      }

      if (parsed?.selectedMonth) {
        setSelectedMonth(parsed.selectedMonth);
      }

      if (Array.isArray(parsed?.monthlyQty)) {
        setMonthlyQty(parsed.monthlyQty);
      }

     setProductTypeFilter("final product");
    } catch (error) {
      console.log("Local storage parse error:", error);
    }
  }, [products, isEditMode, editTargetId]);

  const fetchProducts = async () => {
    try {
      if (!user?.database) return;

      const res = await axiosConfig.get(
        `/product/view-product-purchase/${user.database}`
      );

      const productList = res?.data?.Product || [];
      console.log(
        "========== ALL PRODUCTS ==========",
        productList
      );
      // =====================================================
      // RAW MATERIAL PRODUCTS
      // type = Trading
      // =====================================================

      const rawMaterialProducts = productList.filter(
        (item) =>
          String(item?.type || "")
            .trim()
            .toLowerCase() === "trading"
      );

      // =====================================================
      // FINAL PRODUCTS
      // productSection = Final Product
      // =====================================================

      const finalProducts = productList.filter(
        (item) =>
          String(item?.productSection || "")
            .trim()
            .toLowerCase() === "final product"
      );

      console.log(
        "========== RAW MATERIAL PRODUCTS ==========",
        rawMaterialProducts
      );

      console.log(
        "========== FINAL PRODUCTS ==========",
        finalProducts
      );

      // Saare products state me rakho
      // taaki edit / product lookup break na ho
      setProducts(productList);

    } catch (error) {
      console.log(
        "Product Fetch Error:",
        error
      );
    }
  };

  // =========================================================
  // GET PRODUCT DETAILS
  // =========================================================

  const getProductDetails = (product) => {
    if (!product) return [];

    let specifications = product?.productSpecification || [];

    if (typeof specifications === "string") {
      try {
        specifications = JSON.parse(specifications);
      } catch (error) {
        console.log("PRODUCT SPECIFICATION PARSE ERROR =>", error);
        specifications = [];
      }
    }

    if (!Array.isArray(specifications)) {
      specifications = [];
    }

    const details = [];

    specifications.forEach((spec) => {
      const specificationFields = [
        { key: "netQty", label: "Net Qty" },
        { key: "netSqInch", label: "Net Sq Inch" },
        { key: "netWeight", label: "Net Weight" },

        { key: "grossQty", label: "Gross Qty" },
        { key: "grossSqInch", label: "Gross Sq Inch" },
        { key: "grossWeight", label: "Gross Weight" },

        { key: "qtyInBundle", label: "Qty In Bundle" },
        { key: "qtyInBag", label: "Qty In Bag" },
        { key: "noOfBundleInBag", label: "No Of Bundle In Bag" },

        { key: "weightOfBundle", label: "Weight Of Bundle" },
        { key: "weightOfBag", label: "Weight Of Bag" },

        { key: "wastageSqInch", label: "Wastage Sq Inch" },
        { key: "wastageWeight", label: "Wastage Weight" },
      ];

      specificationFields.forEach(({ key, label }) => {
        if (
          spec[key] !== undefined &&
          spec[key] !== null &&
          spec[key] !== ""
        ) {
          details.push({
            unit: label,
            qty: Number(spec[key]) || 0,
            value: Number(spec[key]) || 0,
            field: key,
            label,
            operator: "*",
          });
        }
      });
    });

    return details;
  };

  // =========================================================
  // PRODUCT OUTPUT CALCULATION
  // =========================================================

  const calculateProductOutput = (
    details,
    qty,
    product
  ) => {
    const target = Number(qty || 0);

    if (!Array.isArray(details) || details.length === 0) {
      return [];
    }

    const productQtyDetails = Array.isArray(
      product?.productQtyDetails
    )
      ? product.productQtyDetails
      : [];

    return details.map((item) => {
      const inputQty = Number(item?.qty || 0);

      const operator = item?.operator || "*";

      const unitName = String(item?.unit || "")
        .trim()
        .toLowerCase();

      const isChildSqInch =
        item?.source === "productUnits" &&
        unitName === "sqinch";

      const isChildWeight =
        item?.source === "productUnits" &&
        (unitName === "kg" ||
          unitName.includes("kilogram"));

      const childId =
        typeof product?.productDetails?.[0]?.productId ===
          "object"
          ? product?.productDetails?.[0]?.productId?._id
          : product?.productDetails?.[0]?.productId;

      const childQty = Number(
        productQtyDetails.find((p) => {
          const pId =
            typeof p?.productId === "object"
              ? p?.productId?._id
              : p?.productId;

          return String(pId) === String(childId);
        })?.qty || 0
      );

      let calculatedQty = 0;

      // -------------------------------------------------------
      // CHILD SQINCH / KG
      // -------------------------------------------------------

      if (
        (isChildSqInch || isChildWeight) &&
        childQty > 0
      ) {
        calculatedQty =
          (inputQty / childQty) * target;
      } else {
        switch (operator) {
          case "+":
            calculatedQty = target + inputQty;
            break;

          case "-":
            calculatedQty = target - inputQty;
            break;

          case "*":
            calculatedQty = target * inputQty;
            break;

          case "/":
            calculatedQty =
              inputQty !== 0
                ? target / inputQty
                : 0;
            break;

          case "%":
            calculatedQty =
              (target * inputQty) / 100;
            break;

          default:
            calculatedQty = target * inputQty;
        }
      }

      return {
        unit: item?.unit || "",
        inputQty,
        targetQty: target,
        operator,
        calculatedQty,
      };
    });
  };

  // =========================================================
  // MONTHLY TOTAL CALCULATION
  // =========================================================

  const calculateMonthlyQty = (
    productsList = targetProducts,
    month = selectedMonth,
    preservePrevious = false,
    oldMonthlyData = monthlyQty,
    type = reportType
  ) => {
    const months = getFinancialYearMonths();

    // =======================================================
    // YEARLY
    // Every product target / 12
    // Then all products are added
    // =======================================================

    if (type === "yearly") {
      const totalPerMonth = productsList.reduce(
        (sum, product) => {
          return (
            sum +
            Number(product?.targetQty || 0) / 12
          );
        },
        0
      );

      const result = months.map((monthName) => ({
        month: monthName,
        qty: totalPerMonth,
      }));

      setMonthlyQty(result);

      return;
    }

    // =======================================================
    // MONTHLY
    // =======================================================

    const selectedIndex = months.indexOf(month);

    if (selectedIndex === -1) {
      return;
    }

    const oldData = Array.isArray(oldMonthlyData)
      ? oldMonthlyData
      : [];

    // All product target qty sum
    const monthlyTarget = productsList.reduce(
      (sum, product) => {
        return (
          sum +
          Number(product?.targetQty || 0)
        );
      },
      0
    );

    const result = months.map(
      (monthName, index) => {
        // ---------------------------------------------------
        // EDIT MODE
        // Selected month se pehle old value rahegi
        // ---------------------------------------------------

        if (
          preservePrevious &&
          index < selectedIndex
        ) {
          const oldItem = oldData.find(
            (item) =>
              item?.month === monthName
          );

          return {
            month: monthName,
            qty: Number(oldItem?.qty || 0),
          };
        }

        // ---------------------------------------------------
        // Selected month onward new total
        // ---------------------------------------------------

        return {
          month: monthName,
          qty: monthlyTarget,
        };
      }
    );

    setMonthlyQty(result);
  };

  // =========================================================
  // ADD PRODUCT
  // =========================================================

  const handleAddProduct = () => {
    const newProduct = createEmptyProduct();

    setTargetProducts((prev) => [
      ...prev,
      newProduct,
    ]);
  };

  // =========================================================
  // REMOVE PRODUCT
  // =========================================================

  const handleRemoveProduct = (index) => {
    if (targetProducts.length === 1) {
      swal(
        "Warning",
        "At least one product is required",
        "warning"
      );

      return;
    }

    setTargetProducts((prev) => {
      const updatedProducts = prev.filter(
        (_, i) => i !== index
      );

      // Recalculate monthly after remove
      setTimeout(() => {
        if (reportType === "yearly") {
          calculateMonthlyQty(
            updatedProducts,
            "",
            false,
            null,
            "yearly"
          );
        } else if (selectedMonth) {
          calculateMonthlyQty(
            updatedProducts,
            selectedMonth,
            isEditMode,
            monthlyQty,
            "monthly"
          );
        }
      }, 0);

      return updatedProducts;
    });
  };

  // =========================================================
  // PRODUCT CHANGE
  // =========================================================

  const handleProductChange = (index, productId) => {
    const product = products.find(
      (item) =>
        String(item?._id) === String(productId)
    );

    if (!product) {
      return;
    }

    // =====================================================
    // DUPLICATE PRODUCT CHECK
    // =====================================================

    const duplicate = targetProducts.some(
      (item, i) =>
        i !== index &&
        String(item?.productId) === String(productId)
    );

    if (duplicate) {
      swal(
        "Warning",
        "This product is already selected",
        "warning"
      );

      return;
    }

    // =====================================================
    // GET PRODUCT DETAILS
    // =====================================================

    let details = getProductDetails(product);

    // =====================================================
    // APPLY LAST SELECTED OPERATOR
    // SAME UNIT => SAME OPERATOR
    // =====================================================

    details = details.map((item) => {
      const unitKey = String(item?.unit || "")
        .trim()
        .toLowerCase();

      return {
        ...item,

        operator:
          unitOperators[unitKey] ||
          item?.operator ||
          "*",
      };
    });

    // =====================================================
    // CALCULATE OUTPUT
    // =====================================================

    const currentTargetQty =
      targetProducts[index]?.targetQty || 0;

    const outputDetails =
      calculateProductOutput(
        details,
        currentTargetQty,
        product
      );

    // =====================================================
    // UPDATE PRODUCTS
    // =====================================================

    const updatedProducts =
      targetProducts.map((item, i) => {
        if (i !== index) {
          return item;
        }
        const rawMaterialDetails = Array.isArray(
          product?.rawMaterialDetails
        )
          ? product.rawMaterialDetails.map((rawItem) => ({
            productId:
              typeof rawItem?.productId === "object"
                ? rawItem?.productId?._id
                : rawItem?.productId || "",

            qty: rawItem?.qty ?? "",

            step_Name: Array.isArray(
              rawItem?.step_Name
            )
              ? rawItem.step_Name
              : rawItem?.step_Name
                ? [rawItem.step_Name]
                : [],
          }))
          : [];
        return {
          ...item,
          productId: product?._id,
          product,
          inputDetails: details,
          outputDetails,
          rawMaterialDetails
        };
      });

    setTargetProducts(updatedProducts);

    // =====================================================
    // RECALCULATE MONTHLY
    // =====================================================

    if (reportType === "yearly") {
      calculateMonthlyQty(
        updatedProducts,
        "",
        false,
        null,
        "yearly"
      );
    } else if (selectedMonth) {
      calculateMonthlyQty(
        updatedProducts,
        selectedMonth,
        isEditMode,
        monthlyQty,
        "monthly"
      );
    }

    saveTargetToLocal({
      updatedTargetProducts: updatedProducts,
    });
  };

  // =========================================================
  // TARGET QTY CHANGE
  // =========================================================

  const handleTargetQtyChange = (
    index,
    value
  ) => {
    const qty = Number(value || 0);

    const updatedProducts =
      targetProducts.map(
        (item, i) => {
          if (i !== index) {
            return item;
          }

          const outputDetails =
            calculateProductOutput(
              item?.inputDetails || [],
              qty,
              item?.product
            );

          return {
            ...item,
            targetQty: value,
            outputDetails,
          };
        }
      );

    setTargetProducts(updatedProducts);

    // -------------------------------------------------------
    // RECALCULATE MONTHLY
    // -------------------------------------------------------

    if (reportType === "yearly") {
      calculateMonthlyQty(
        updatedProducts,
        "",
        false,
        null,
        "yearly"
      );
    } else if (selectedMonth) {
      calculateMonthlyQty(
        updatedProducts,
        selectedMonth,
        isEditMode,
        monthlyQty,
        "monthly"
      );
    }

    saveTargetToLocal({
      updatedTargetProducts: updatedProducts,
    });
  };

  // =========================================================
  // OPERATOR CHANGE
  // =========================================================

  const handleOperatorChange = (
    productIndex,
    detailIndex,
    operator
  ) => {
    const currentProduct =
      targetProducts[productIndex];

    if (!currentProduct) {
      return;
    }

    const currentDetail =
      currentProduct?.inputDetails?.[
      detailIndex
      ];

    const unitKey = String(
      currentDetail?.unit || ""
    )
      .trim()
      .toLowerCase();

    // =====================================================
    // SAVE OPERATOR FOR THIS UNIT
    // =====================================================

    setUnitOperators((prev) => ({
      ...prev,
      [unitKey]: operator,
    }));

    // =====================================================
    // UPDATE CURRENT PRODUCT
    // =====================================================

    const updatedProducts =
      targetProducts.map(
        (productItem, productIndexValue) => {
          if (
            productIndexValue !==
            productIndex
          ) {
            return productItem;
          }

          const updatedInputDetails = [
            ...(productItem?.inputDetails || []),
          ];

          updatedInputDetails[
            detailIndex
          ] = {
            ...updatedInputDetails[
            detailIndex
            ],
            operator,
          };

          // =================================================
          // OUTPUT RECALCULATE
          // =================================================

          const outputDetails =
            calculateProductOutput(
              updatedInputDetails,
              productItem?.targetQty,
              productItem?.product
            );

          return {
            ...productItem,
            inputDetails:
              updatedInputDetails,
            outputDetails,
          };
        }
      );

    setTargetProducts(updatedProducts);

    // =====================================================
    // MONTHLY RECALCULATE
    // =====================================================

    if (reportType === "yearly") {
      calculateMonthlyQty(
        updatedProducts,
        "",
        false,
        null,
        "yearly"
      );
    } else if (selectedMonth) {
      calculateMonthlyQty(
        updatedProducts,
        selectedMonth,
        isEditMode,
        monthlyQty,
        "monthly"
      );
    }

    saveTargetToLocal({
      updatedTargetProducts:
        updatedProducts,
    });
  };

  // =========================================================
  // LOCAL STORAGE
  // =========================================================

  const saveTargetToLocal = ({
    updatedTargetProducts = targetProducts,
    updatedReportType = reportType,
    updatedFinancialYear = financialYear,
    updatedSelectedMonth = selectedMonth,
    updatedMonthlyQty = monthlyQty,
    updatedProductType = productTypeFilter,
  }) => {
    const data = {
      targetProducts: updatedTargetProducts.map((item) => ({
        id: item?.id || "",
        productId: item?.productId || "",
        targetQty: item?.targetQty ?? "",

        inputDetails: Array.isArray(item?.inputDetails)
          ? item.inputDetails.map((detail) => ({
            unit: detail?.unit || "",
            qty: Number(detail?.qty || 0),
            value: detail?.value ?? "",
            field: detail?.field || "",
            label: detail?.label || "",
            operator: detail?.operator || "*",
          }))
          : [],

        outputDetails: Array.isArray(item?.outputDetails)
          ? item.outputDetails.map((detail) => ({
            unit: detail?.unit || "",
            inputQty: Number(detail?.inputQty || 0),
            targetQty: Number(detail?.targetQty || 0),
            operator: detail?.operator || "*",
            calculatedQty: Number(detail?.calculatedQty || 0),
          }))
          : [],

        rawMaterialDetails: Array.isArray(item?.rawMaterialDetails)
          ? item.rawMaterialDetails.map((rawItem) => ({
            productId:
              typeof rawItem?.productId === "object"
                ? rawItem?.productId?._id
                : rawItem?.productId || "",

            qty: rawItem?.qty ?? "",

            step_Name: Array.isArray(rawItem?.step_Name)
              ? rawItem.step_Name
              : rawItem?.step_Name
                ? [rawItem.step_Name]
                : [],
          }))
          : [],

        // ================================
        // PRODUCTION MATERIALS
        // ================================
        productionMaterials: Array.isArray(
          item?.product?.productionMaterials
        )
          ? item.product.productionMaterials.map((material) => ({
            productId:
              typeof material?.productId === "object"
                ? material?.productId?._id
                : material?.productId || "",

            productName:
              typeof material?.productId === "object"
                ? material?.productId?.Product_Title || ""
                : "",

            qtyRequired: Number(material?.qtyRequired || 0),

            basicPrice: Number(material?.basicPrice || 0),

            total: Number(material?.total || 0),
          }))
          : [],
      })),

      reportType: updatedReportType,

      financialYear: updatedFinancialYear,

      selectedMonth: updatedSelectedMonth,

      monthlyQty: updatedMonthlyQty,

      productTypeFilter: updatedProductType,
    };

    localStorage.setItem(
      TARGET_STORAGE_KEY,
      JSON.stringify(data)
    );
  };

  // =========================================================
  // FILTER PRODUCTS
  // =========================================================

const filteredProducts = products.filter((product) => {
  return (
    String(product?.productSection || "")
      .trim()
      .toLowerCase() === "final product"
  );
});


  // =========================================================
  // FETCH TARGET BY ID
  // =========================================================

  const fetchTargetById = async (id) => {
    try {
      if (!id) {
        return;
      }

      setLoading(true);

      const res =
        await axiosConfig.get(
          `/production-steps/view-by-target-id/${id}`
        );
      console.log(
        "VIEW TARGET BY ID RESPONSE =>",
        res?.data
      );

      const data =
        res?.data?.data ||
        res?.data?.target ||
        res?.data;

      if (!data) {
        swal(
          "Error",
          "Target data not found",
          "error"
        );

        return;
      }

      populateEditForm(data);
    } catch (error) {
      console.error(
        "View Worker Target Error:",
        error
      );

      swal(
        "Error",
        error?.response?.data?.message ||
        "Unable to load target",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  // =========================================================
  // POPULATE EDIT FORM
  // =========================================================

  const populateEditForm = (data) => {
    // -------------------------------------------------------
    // REPORT TYPE
    // -------------------------------------------------------

    const currentReportType =
      data?.reportType || "monthly";

    setReportType(currentReportType);

    // -------------------------------------------------------
    // FINANCIAL YEAR
    // -------------------------------------------------------

    setFinancialYear(
      data?.financialYear ||
      getFinancialYear()
    );

    // -------------------------------------------------------
    // MONTH DATA
    // -------------------------------------------------------

    const monthArray =
      Array.isArray(data?.month)
        ? data.month
        : [];

    const existingMonthlyQty =
      monthArray.map((item) => {
        const monthName =
          Object.keys(item || {})[0];

        return {
          month: monthName,
          qty: Number(
            item?.[monthName] || 0
          ),
        };
      });

    setMonthlyQty(
      existingMonthlyQty
    );

    // -------------------------------------------------------
    // IMPORTANT
    // Exact month clicked from Target.jsx
    // -------------------------------------------------------

    if (
      currentReportType === "monthly"
    ) {
      setSelectedMonth(
        editData?.month || ""
      );
    } else {
      setSelectedMonth("");
    }

    // -------------------------------------------------------
    // MULTIPLE PRODUCTS
    // -------------------------------------------------------

    const savedProducts =
      Array.isArray(data?.products)
        ? data.products
        : [];

    if (savedProducts.length === 0) {
      setTargetProducts([
        createEmptyProduct(),
      ]);

      return;
    }

    const editProducts =
      savedProducts.map(
        (item, index) => {
          const product =
            products.find(
              (p) =>
                String(p?._id) ===
                String(
                  item?.productId
                )
            );

          // -------------------------------------------------
          // INPUT DETAILS
          // -------------------------------------------------

          const generatedInputDetails =
            getProductDetails(product);

          const savedInputDetails =
            Array.isArray(
              item?.inputProductDetails
            )
              ? item.inputProductDetails
              : [];

          const inputDetails =
            savedInputDetails.length > 0
              ? generatedInputDetails.map(
                (detail) => {
                  const savedDetail =
                    savedInputDetails.find(
                      (saved) =>
                        String(
                          saved?.unit
                        )
                          .trim()
                          .toLowerCase() ===
                        String(
                          detail?.unit
                        )
                          .trim()
                          .toLowerCase()
                    );

                  return {
                    ...detail,
                    operator:
                      savedDetail?.operator ||
                      detail?.operator ||
                      "*",
                  };
                }
              )
              : generatedInputDetails;

          // -------------------------------------------------
          // OUTPUT DETAILS
          // -------------------------------------------------

          const savedOutputDetails =
            Array.isArray(
              item?.outputProductDetails
            )
              ? item.outputProductDetails
              : [];

          const outputDetails =
            savedOutputDetails.length > 0
              ? savedOutputDetails
              : calculateProductOutput(
                inputDetails,
                item?.targetQty,
                product
              );
          // -------------------------------------------------
          // RAW MATERIAL DETAILS
          // -------------------------------------------------

          const rawMaterialDetails = Array.isArray(
            product?.rawMaterialDetails
          )

            ? product.rawMaterialDetails.map((rawItem) => ({
              productId:
                typeof rawItem?.productId === "object"
                  ? rawItem?.productId?._id
                  : rawItem?.productId || "",

              qty: rawItem?.qty ?? "",

              step_Name: Array.isArray(
                rawItem?.step_Name
              )
                ? rawItem.step_Name
                : rawItem?.step_Name
                  ? [rawItem.step_Name]
                  : [],
            }))
            : [];
          const productionMaterials = Array.isArray(
            product?.productionMaterials
          )
            ? product.productionMaterials.map((material) => ({
              productId:
                typeof material?.productId === "object"
                  ? material.productId?._id
                  : material?.productId || "",

              qtyRequired:
                Number(material?.qtyRequired || 0),

              basicPrice:
                Number(material?.basicPrice || 0),

              total:
                Number(material?.total || 0),
            }))
            : [];
          return {
            id:
              Date.now() +
              index +
              Math.random(),

            productId:
              item?.productId || "",

            product,

            targetQty:
              Number(
                item?.targetQty || 0
              ),

            inputDetails,

            outputDetails,
            rawMaterialDetails,
            productionMaterials
          };
        }
      );

    setTargetProducts(
      editProducts.length > 0
        ? editProducts
        : [createEmptyProduct()]
    );

    // -------------------------------------------------------
    // PRODUCT TYPE
    // -------------------------------------------------------

   setProductTypeFilter("final product");
    const savedOperators = {};

    editProducts.forEach((productItem) => {
      (productItem?.inputDetails || []).forEach(
        (detail) => {
          const unitKey = String(
            detail?.unit || ""
          )
            .trim()
            .toLowerCase();

          if (unitKey) {
            savedOperators[unitKey] =
              detail?.operator || "*";
          }
        }
      );
    });

    setUnitOperators(savedOperators);
  };

  // =========================================================
  // VALIDATE
  // =========================================================

  const validateForm = () => {
    if (!reportType) {
      swal(
        "Warning",
        "Select Target Type",
        "warning"
      );

      return false;
    }

    if (!financialYear) {
      swal(
        "Warning",
        "Select Financial Year",
        "warning"
      );

      return false;
    }

    if (
      reportType === "monthly" &&
      !selectedMonth
    ) {
      swal(
        "Warning",
        "Select Month",
        "warning"
      );

      return false;
    }

    // -------------------------------------------------------
    // PRODUCT VALIDATION
    // -------------------------------------------------------

    const validProducts =
      targetProducts.filter(
        (item) => item?.productId
      );

    if (validProducts.length === 0) {
      swal(
        "Warning",
        "Select at least one product",
        "warning"
      );

      return false;
    }

    // -------------------------------------------------------
    // QTY VALIDATION
    // -------------------------------------------------------

    const invalidProduct =
      validProducts.find(
        (item) =>
          Number(item?.targetQty || 0) <= 0
      );

    if (invalidProduct) {
      swal(
        "Warning",
        `Enter Target Qty for ${invalidProduct?.product
          ?.Product_Title || "product"
        }`,
        "warning"
      );

      return false;
    }

    return true;
  };

  // =========================================================
  // PAYLOAD
  // =========================================================

  // const buildPayload = () => {
  //   return {
  //     created_by: user?._id,

  //     database: user?.database,

  //     reportType,

  //     financialYear,

  //     month: monthlyQty.map(
  //       (item) => ({
  //         [item.month]:
  //           Number(item.qty || 0),
  //       })
  //     ),

  //     products: targetProducts
  //       .filter(
  //         (item) => item?.productId
  //       )
  //       .map((item) => ({
  //         productId:
  //           item?.productId,

  //         productName:
  //           item?.product
  //             ?.Product_Title || "",

  //         targetQty:
  //           Number(
  //             item?.targetQty || 0
  //           ),

  //         inputProductDetails:
  //           (item?.inputDetails || [])
  //             .map((detail) => ({
  //               unit:
  //                 detail?.unit || "",

  //               qty:
  //                 Number(
  //                   detail?.qty || 0
  //                 ),

  //               source:
  //                 detail?.source || "",

  //               operator:
  //                 detail?.operator ||
  //                 "*",
  //             })),

  //         outputProductDetails:
  //           (item?.outputDetails || [])
  //             .map((detail) => ({
  //               unit:
  //                 detail?.unit || "",

  //               inputQty:
  //                 Number(
  //                   detail?.inputQty || 0
  //                 ),

  //               targetQty:
  //                 Number(
  //                   detail?.targetQty || 0
  //                 ),

  //               operator:
  //                 detail?.operator ||
  //                 "*",

  //               calculatedQty:
  //                 Number(
  //                   detail?.calculatedQty ||
  //                   0
  //                 ),

  //             })),
  //         rawMaterialDetails:
  //           (item?.rawMaterialDetails || [])
  //             .filter(
  //               (rawItem) => rawItem?.productId
  //             )
  //             .map((rawItem) => ({
  //               productId:
  //                 typeof rawItem?.productId === "object"
  //                   ? rawItem.productId?._id
  //                   : rawItem.productId,

  //               qty: rawItem?.qty ?? "",

  //               step_Name:
  //                 Array.isArray(rawItem?.step_Name)
  //                   ? rawItem.step_Name
  //                   : rawItem?.step_Name
  //                     ? [rawItem.step_Name]
  //                     : [],
  //             })),
  //         productionMaterials:
  //           Array.isArray(item?.product?.productionMaterials)
  //             ? item.product.productionMaterials.map((material) => ({
  //               productId:
  //                 typeof material?.productId === "object"
  //                   ? material.productId?._id
  //                   : material?.productId || "",

  //               productName:
  //                 typeof material?.productId === "object"
  //                   ? material?.productId?.Product_Title || ""
  //                   : "",

  //               qtyRequired:
  //                 Number(material?.qtyRequired || 0),

  //               basicPrice:
  //                 Number(material?.basicPrice || 0),

  //               total:
  //                 Number(
  //                   Number(material?.qtyRequired || 0) *
  //                   Number(item?.targetQty || 0)
  //                 ),
  //             }))
  //             : [],
  //       })),
  //   };
  // };
const buildPayload = () => {
  // ==========================================
  // ALL PRODUCTION MATERIALS
  // ==========================================
  const allProductionMaterials = targetProducts
    .filter((item) => item?.productId)
    .flatMap((item) => {
      const targetQty = Number(item?.targetQty || 0);

      if (!Array.isArray(item?.product?.productionMaterials)) {
        return [];
      }

      return item.product.productionMaterials.map((material) => {
        const qtyRequired = Number(
          material?.qtyRequired || 0
        );

        const basicPrice = Number(
          material?.basicPrice || 0
        );

        const materialProductId =
          typeof material?.productId === "object"
            ? material?.productId?._id
            : material?.productId || "";

        const materialProductName =
          typeof material?.productId === "object"
            ? material?.productId?.Product_Title || ""
            : "";

        return {
          productId: materialProductId,

          productName: materialProductName,

          qtyRequired: qtyRequired,

          basicPrice: basicPrice,

          targetQty: targetQty,

          total: qtyRequired * targetQty,
        };
      });
    });

  // ==========================================
  // FINAL PAYLOAD
  // ==========================================
  const payload = {
    created_by: user?._id,

    database: user?.database,

    reportType: reportType,

    financialYear: financialYear,

    month: monthlyQty.map((item) => ({
      [item.month]: Number(item.qty || 0),
    })),

    // ==========================================
    // TOP LEVEL PRODUCTION MATERIALS
    // ==========================================
    productionMaterials: allProductionMaterials,

    // ==========================================
    // PRODUCTS
    // ==========================================
    products: targetProducts
      .filter((item) => item?.productId)
      .map((item) => {
        const targetQty = Number(
          item?.targetQty || 0
        );

        return {
          productId: item?.productId || "",

          productName:
            item?.product?.Product_Title || "",

          targetQty: targetQty,

          // ==========================================
          // INPUT DETAILS
          // ==========================================
          inputProductDetails: Array.isArray(
            item?.inputDetails
          )
            ? item.inputDetails.map((detail) => ({
                unit: detail?.unit || "",

                qty: Number(detail?.qty || 0),

                source: detail?.source || "",

                operator:
                  detail?.operator || "*",
              }))
            : [],

          // ==========================================
          // OUTPUT DETAILS
          // ==========================================
          outputProductDetails: Array.isArray(
            item?.outputDetails
          )
            ? item.outputDetails.map((detail) => ({
                unit: detail?.unit || "",

                inputQty: Number(
                  detail?.inputQty || 0
                ),

                targetQty: Number(
                  detail?.targetQty || 0
                ),

                operator:
                  detail?.operator || "*",

                calculatedQty: Number(
                  detail?.calculatedQty || 0
                ),
              }))
            : [],

          // ==========================================
          // RAW MATERIAL DETAILS
          // ==========================================
          rawMaterialDetails: Array.isArray(
            item?.rawMaterialDetails
          )
            ? item.rawMaterialDetails
                .filter(
                  (rawItem) =>
                    rawItem?.productId
                )
                .map((rawItem) => ({
                  productId:
                    typeof rawItem?.productId ===
                    "object"
                      ? rawItem?.productId?._id
                      : rawItem?.productId,

                  qty: rawItem?.qty ?? "",

                  step_Name: Array.isArray(
                    rawItem?.step_Name
                  )
                    ? rawItem.step_Name
                    : rawItem?.step_Name
                    ? [rawItem.step_Name]
                    : [],
                }))
            : [],
        };
      }),
  };

  return payload;
};


  // =========================================================
  // SUBMIT
  // =========================================================

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    try {
      setLoading(true);

      const payload =
        buildPayload();
console.log(
  "========== PRODUCTION MATERIALS =========="
);

console.log(
  payload.productionMaterials
);

console.log(
  "========== FULL TARGET PAYLOAD =========="
);

console.log(
  JSON.stringify(payload, null, 2)
);
      console.log(
        "FINAL TARGET PAYLOAD =>",
        payload
      );
      let res;

      // =====================================================
      // EDIT
      // =====================================================

      if (
        isEditMode &&
        editTargetId
      ) {
        console.log(
          "EDIT TARGET ID =>",
          editTargetId
        );

        console.log(
          "UPDATE PAYLOAD =>",
          JSON.stringify(
            payload,
            null,
            2
          )
        );

        res =
          await axiosConfig.put(
            `/production-steps/update-workerTaget/${editTargetId}`,
            payload
          );

        console.log(
          "PUT STATUS =>",
          res?.status
        );

        console.log(
          "PUT RESPONSE =>",
          res?.data
        );
      }

      // =====================================================
      // CREATE
      // =====================================================

      else {
        res =
          await axiosConfig.post(
            "/production-steps/save-worker-target",
            payload
          );
      }

      console.log(
        "TARGET SAVE RESPONSE =>",
        res?.data
      );

      if (
        res?.status === 200 ||
        res?.status === 201 ||
        res?.data?.status
      ) {
        localStorage.removeItem(
          TARGET_STORAGE_KEY
        );

        swal(
          "Success",
          isEditMode
            ? "Target Updated Successfully"
            : "Target Saved Successfully",
          "success"
        );

        navigate(
          "/sales-and-purchases?view=targets"
        );
      } else {
        swal(
          "Error",
          isEditMode
            ? "Unable to update target"
            : "Unable to save target",
          "error"
        );
      }
    } catch (error) {
      console.log(
        "Target Submit Error:",
        error
      );

      swal(
        "Error",
        error?.response?.data
          ?.message ||
        "Something Went Wrong",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  // =========================================================
  // TARGET TYPE CHANGE
  // =========================================================

  const handleReportTypeChange = (
    e
  ) => {
    const type =
      e.target.value;

    setReportType(type);

    if (type === "yearly") {
      // -----------------------------------------------------
      // Yearly:
      // Product1 / 12 + Product2 / 12 ...
      // -----------------------------------------------------

      calculateMonthlyQty(
        targetProducts,
        "",
        false,
        null,
        "yearly"
      );

      setSelectedMonth("");
    } else {
      // -----------------------------------------------------
      // Monthly
      // -----------------------------------------------------

      setMonthlyQty([]);

      setSelectedMonth("");
    }

    saveTargetToLocal({
      updatedReportType: type,
      updatedSelectedMonth:
        type === "yearly"
          ? ""
          : selectedMonth,
    });
  };

  // =========================================================
  // MONTH CHANGE
  // =========================================================

  const handleMonthChange = (
    e
  ) => {
    const month =
      e.target.value;

    setSelectedMonth(month);

    if (!month) {
      setMonthlyQty([]);

      return;
    }

    calculateMonthlyQty(
      targetProducts,
      month,
      isEditMode,
      monthlyQty,
      "monthly"
    );
  };

  // =========================================================
  // PRODUCT TYPE CHANGE
  // =========================================================



  // =========================================================
  // RENDER
  // =========================================================
  const handleDeleteTarget = async () => {
    const confirmDelete = await swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete this target?",
      icon: "warning",
      buttons: ["Cancel", "Delete"],
      dangerMode: true,
    });

    if (!confirmDelete) return;

    try {
      await axiosConfig.delete(
        `/production-steps/delete-workerTaget/${editTargetId}`
      );

      swal(
        "Success",
        "Target deleted successfully",
        "success"
      );

      navigate("/sales-and-purchases?view=targets");
    } catch (error) {
      console.error("Delete Target Error:", error);

      swal(
        "Error",
        error?.response?.data?.message ||
        "Unable to delete target",
        "error"
      );
    }
  };
  return (
    <div className="container-fluid">
      <Card>
        <CardHeader>
          <h3 className="mb-0">
            {isEditMode
              ? "Edit Target"
              : "Create Target"}
          </h3>
        </CardHeader>

        <CardBody>
          <Form onSubmit={handleSubmit}>

            {/* =================================================
                 TARGET TYPE / FY / MONTH / PRODUCT TYPE
            ================================================= */}

            <Row>
              {/* TARGET TYPE */}
              <Col md="4">
                <FormGroup>
                  <Label>
                    Target Type
                  </Label>

                  <Input
                    type="select"
                    value={reportType}
                    onChange={
                      handleReportTypeChange
                    }
                  >
                    <option value="monthly">
                      Monthly
                    </option>

                    <option value="yearly">
                      Yearly
                    </option>
                  </Input>
                </FormGroup>
              </Col>

              {/* FINANCIAL YEAR */}
              <Col md="4">
                <FormGroup>
                  <Label>
                    Financial Year
                  </Label>

                  <Input
                    type="select"
                    value={
                      financialYear
                    }
                    onChange={(e) =>
                      setFinancialYear(
                        e.target.value
                      )
                    }
                  >
                    {getFinancialYearOptions().map(
                      (item) => (
                        <option
                          key={item}
                          value={item}
                        >
                          {item}
                        </option>
                      )
                    )}
                  </Input>
                </FormGroup>
              </Col>

              {/* MONTH */}
              {reportType ===
                "monthly" && (
                  <Col md="4">
                    <FormGroup>
                      <Label>
                        Month
                      </Label>

                      <Input
                        type="select"
                        value={
                          selectedMonth
                        }
                        onChange={
                          handleMonthChange
                        }
                      >
                        <option value="">
                          Select Month
                        </option>

                        {getFinancialYearMonths().map(
                          (month) => (
                            <option
                              key={month}
                              value={month}
                            >
                              {month}
                            </option>
                          )
                        )}
                      </Input>
                    </FormGroup>
                  </Col>
                )}

              
            </Row>

            {/* =================================================
                 MULTIPLE PRODUCTS
            ================================================= */}

            {targetProducts.map(
              (item, index) => (
                <Card
                  key={item?.id}
                  className="mt-3"
                >
                  <CardHeader>
                    <div className="d-flex justify-content-between align-items-center">
                      <h5 className="mb-0">
                        Product{" "}
                        {index + 1}
                      </h5>

                      {targetProducts.length >
                        1 && (
                          <Button
                            color="danger"
                            size="sm"
                            type="button"
                            onClick={() =>
                              handleRemoveProduct(
                                index
                              )
                            }
                          >
                            Remove
                          </Button>
                        )}
                    </div>
                  </CardHeader>

                  <CardBody>

                    {/* =========================================
                         PRODUCT + TARGET QTY
                    ========================================= */}

                    <Row>
                      {/* PRODUCT */}
                      <Col md="6">
                        <FormGroup>
                          <Label>
                            Product
                          </Label>

                          <Input
                            type="select"
                            value={
                              item?.productId ||
                              ""
                            }
                            onChange={(e) =>
                              handleProductChange(
                                index,
                                e.target.value
                              )
                            }
                            disabled={
                              !productTypeFilter
                            }
                          >
                            <option value="">
                              {productTypeFilter
                                ? "Select Product"
                                : "First Select Product Type"}
                            </option>

                            {filteredProducts
                              .filter(
                                (product) => {
                                  // Same product ko
                                  // current row me allow karo
                                  // lekin dusri rows me nahi
                                  const alreadySelected =
                                    targetProducts.some(
                                      (
                                        selected,
                                        selectedIndex
                                      ) =>
                                        selectedIndex !==
                                        index &&
                                        String(
                                          selected?.productId
                                        ) ===
                                        String(
                                          product?._id
                                        )
                                    );

                                  return (
                                    !alreadySelected ||
                                    String(
                                      product?._id
                                    ) ===
                                    String(
                                      item?.productId
                                    )
                                  );
                                }
                              )
                              .map(
                                (product) => (
                                  <option
                                    key={
                                      product?._id
                                    }
                                    value={
                                      product?._id
                                    }
                                  >
                                    {
                                      product?.Product_Title
                                    }
                                  </option>
                                )
                              )}
                          </Input>
                        </FormGroup>
                      </Col>

                      {/* TARGET QTY */}
                      <Col md="6">
                        <FormGroup>
                          <Label>
                            Target Qty
                          </Label>

                          <Input
                            type="number"
                            min="0"
                            value={
                              item?.targetQty ??
                              ""
                            }
                            onChange={(e) =>
                              handleTargetQtyChange(
                                index,
                                e.target.value
                              )
                            }
                            disabled={
                              !item?.productId
                            }
                          />
                        </FormGroup>
                      </Col>

                    </Row>
                    {item?.rawMaterialDetails?.length > 0 && (
                      <Card className="mt-3">
                        <CardHeader>
                          <h6 className="mb-0">
                            Raw Material Details
                          </h6>
                        </CardHeader>

                        <CardBody>
                          <div className="table-responsive">
                            <table className="table table-bordered">
                              <thead>
                                <tr>
                                  <th>Raw Material</th>
                                  <th>Qty</th>
                                  <th>Product Steps</th>
                                </tr>
                              </thead>

                              <tbody>
                                {item.rawMaterialDetails.map(
                                  (rawItem, rawIndex) => {

                                    const rawProduct =
                                      products.find(
                                        (product) =>
                                          String(product?._id) ===
                                          String(rawItem?.productId)
                                      );

                                    return (
                                      <tr
                                        key={
                                          rawItem?._id ||
                                          rawIndex
                                        }
                                      >
                                        <td>
                                          {rawProduct?.Product_Title ||
                                            rawItem?.productId ||
                                            "-"}
                                        </td>

                                        <td>
                                          {rawItem?.qty ?? 0}
                                        </td>

                                        <td>
                                          {Array.isArray(
                                            rawItem?.step_Name
                                          ) &&
                                            rawItem.step_Name.length > 0 ? (
                                            <div className="d-flex flex-wrap">
                                              {rawItem.step_Name.map(
                                                (step, stepIndex) => (
                                                  <span
                                                    key={stepIndex}
                                                    className="badge bg-primary me-1 mb-1"
                                                  >
                                                    {step}
                                                  </span>
                                                )
                                              )}
                                            </div>
                                          ) : (
                                            <span className="text-muted">
                                              No Step
                                            </span>
                                          )}
                                        </td>
                                      </tr>
                                    );
                                  }
                                )}
                              </tbody>
                            </table>
                          </div>
                        </CardBody>
                      </Card>
                    )}
                    {/* STEP NAME */}
                    {item?.product?.step_Name?.length > 0 && (
                      <div className="mb-3">
                        <label className="fw-bold d-block">
                          Step Name
                        </label>

                        <div className="d-flex flex-wrap gap-2">
                          {item.product.step_Name.map((step, stepIndex) => (
                            <span
                              key={stepIndex}
                              className="badge bg-primary me-2"
                            >
                              {step}
                            </span>
                          ))}
                        </div>
                      </div>
                    )}
                    {/* =========================================
                         INPUT DETAILS
                    ========================================= */}

                    <Card className="mt-3">
                      <CardHeader>
                        <h6 className="mb-0">
                          Input Product Details
                        </h6>
                      </CardHeader>

                      <CardBody>
                        {item
                          ?.inputDetails
                          ?.length === 0 ? (
                          <div className="text-muted">
                            Select product to
                            view input units
                          </div>
                        ) : (
                          <Row>
                            {item.inputDetails.map(
                              (
                                detail,
                                detailIndex
                              ) => (
                                <Col
                                  md="3"
                                  sm="6"
                                  xs="12"
                                  key={
                                    detailIndex
                                  }
                                  className="mb-3"
                                >
                                  <div
                                    className="border rounded p-3 h-100"
                                    style={{
                                      background:
                                        "#fff",
                                      boxShadow:
                                        "0 1px 4px rgba(0,0,0,0.08)",
                                    }}
                                  >
                                    <div className="d-flex align-items-center justify-content-between mb-2">

                                      {/* UNIT */}
                                      <strong>
                                        {detail?.unit ||
                                          "-"}
                                      </strong>

                                      {/* OPERATOR */}
                                      <Input
                                        type="select"
                                        bsSize="sm"
                                        value={
                                          detail?.operator ||
                                          "*"
                                        }
                                        style={{
                                          width:
                                            "65px",
                                          minWidth:
                                            "65px",
                                          fontWeight:
                                            "bold",
                                          textAlign:
                                            "center",
                                        }}
                                        onChange={(
                                          e
                                        ) =>
                                          handleOperatorChange(
                                            index,
                                            detailIndex,
                                            e
                                              .target
                                              .value
                                          )
                                        }
                                      >
                                        <option value="*">
                                          ×
                                        </option>

                                        <option value="+">
                                          +
                                        </option>

                                        <option value="-">
                                          −
                                        </option>

                                        <option value="/">
                                          ÷
                                        </option>

                                        <option value="%">
                                          %
                                        </option>
                                      </Input>
                                    </div>

                                    {/* INPUT QTY */}
                                    <Input
                                      type="number"
                                      bsSize="sm"
                                      value={
                                        detail?.qty ??
                                        0
                                      }
                                      readOnly
                                      style={{
                                        fontWeight:
                                          "500",
                                        background:
                                          "#f8f9fa",
                                      }}
                                    />
                                  </div>
                                </Col>
                              )
                            )}
                          </Row>
                        )}
                      </CardBody>
                    </Card>
                    {/* ================= PRODUCTION MATERIALS ================= */}
                    {item?.product?.productionMaterials?.length > 0 && (
                      <Card className="mt-3">
                        <CardHeader>
                          <h6 className="mb-0">
                            Production Materials
                          </h6>
                        </CardHeader>

                        <CardBody>
                          <div className="table-responsive">
                            <table className="table table-bordered">
                              <thead>
                                <tr>
                                  <th>Product Name</th>
                                  <th>Product Qty</th>
                                  <th>Total Qty</th>
                                </tr>
                              </thead>

                              <tbody>
                                {item.product.productionMaterials.map(
                                  (material, materialIndex) => {
                                    const targetQty = Number(item?.targetQty || 0);

                                    const productQty = Number(
                                      material?.qtyRequired || 0
                                    );

                                    const totalQty = productQty * targetQty;

                                    return (
                                      <tr key={materialIndex}>
                                        {/* PRODUCT NAME */}
                                        <td>
                                          {material?.productId?.Product_Title || "-"}
                                        </td>

                                        {/* ORIGINAL PRODUCT QTY */}
                                        <td>
                                          {productQty}
                                        </td>

                                        {/* TARGET QTY × PRODUCT QTY */}
                                        <td>
                                          <strong>{totalQty}</strong>
                                        </td>
                                      </tr>
                                    );
                                  }
                                )}
                              </tbody>
                            </table>
                          </div>
                        </CardBody>
                      </Card>
                    )}
                    {/* =========================================
                         OUTPUT DETAILS
                    ========================================= */}

                    <Card className="mt-3">
                      <CardHeader>
                        <h6 className="mb-0">
                          Output Product Details
                        </h6>
                      </CardHeader>

                      <CardBody>
                        {item
                          ?.outputDetails
                          ?.length === 0 ? (
                          <div className="text-muted">
                            Enter target quantity
                            to calculate output
                          </div>
                        ) : (
                          <div className="table-responsive">
                            <table className="table table-bordered">
                              <thead>
                                <tr>
                                  <th>
                                    Unit
                                  </th>

                                  <th>
                                    Input Qty
                                  </th>

                                  <th>
                                    Operator
                                  </th>

                                  <th>
                                    Target Qty
                                  </th>

                                  <th>
                                    Calculated Qty
                                  </th>
                                </tr>
                              </thead>

                              <tbody>
                                {item.outputDetails.map(
                                  (
                                    output,
                                    outputIndex
                                  ) => (
                                    <tr
                                      key={
                                        outputIndex
                                      }
                                    >
                                      <td>
                                        {
                                          output?.unit
                                        }
                                      </td>

                                      <td>
                                        {
                                          output?.inputQty
                                        }
                                      </td>

                                      <td>
                                        {output?.operator ===
                                          "*"
                                          ? "×"
                                          : output?.operator ===
                                            "/"
                                            ? "÷"
                                            : output?.operator}
                                      </td>

                                      <td>
                                        {
                                          output?.targetQty
                                        }
                                      </td>

                                      <td>
                                        <strong>
                                          {Number(
                                            output?.calculatedQty ||
                                            0
                                          ).toFixed(
                                            2
                                          )}
                                        </strong>
                                      </td>
                                    </tr>
                                  )
                                )}
                              </tbody>
                            </table>
                          </div>
                        )}
                      </CardBody>
                    </Card>

                  </CardBody>
                </Card>
              )
            )}

            {/* =================================================
                 ADD MORE PRODUCT
            ================================================= */}

            <div className="mt-3">
              <Button
                color="success"
                type="button"
                onClick={
                  handleAddProduct
                }
              >
                + Add More Product
              </Button>
            </div>

          
            <Row className="mt-4">
              <Col
                md="12"
                className="text-center"
              >
                {/* DELETE BUTTON - Only Edit Mode */}
                {isEditMode && editTargetId && (
                  <Button
                    color="danger"
                    type="button"
                    onClick={handleDeleteTarget}
                    style={{
                      marginRight: "5px",
                    }}
                  >
                    Delete Target
                  </Button>
                )}

                {/* SAVE / UPDATE */}
                <Button
                  color="primary"
                  type="submit"
                  disabled={loading}
                >
                  {loading
                    ? isEditMode
                      ? "Updating..."
                      : "Saving..."
                    : isEditMode
                      ? "Update Target"
                      : "Save Target"}
                </Button>

                {/* CANCEL */}
                <Button
                  style={{
                    marginLeft: "5px",
                  }}
                  color="secondary"
                  type="button"
                  onClick={() =>
                    navigate(
                      "/sales-and-purchases?view=targets"
                    )
                  }
                >
                  Cancel
                </Button>
              </Col>
            </Row>



          </Form>
        </CardBody>
      </Card>
    </div>
  );
};

export default CreateTarget;